import { State } from '../Store';

export const selectCustomerProducts = (state: State) => state.customerProducts;

export const selectCustomerProductsById = (customerId: number) => (
  state: State
) => selectCustomerProducts(state)[customerId];
